import { memo } from "react";
import { Typography } from "@mui/material";
import Popup from "../Popup.js";
import Form from "../Form.js";
import { SecondaryBorderButton } from "../Buttons.js";

const OrderExecutionPopup = ({
    width = "700px",
    isOpen,
    title,
    titleColor = "black",
    onClose,
    innerText = "",
    onExecuted,
    onNotExecuted,
    acceptText = "Δεν έχει εκτελεστεί",
    formContent = [
        {
            customType: "date-picker",
            id: "executionDate",
            type: "desktop",
            label: "Ημ/νία Εκτέλεσης Παρραγελίας",
            width: "600px",
            background: "third",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Οκ",
        },
    ],
}) => {
    return (
        <Popup
            width={width}
            open={isOpen}
            title={title}
            titleColor={titleColor}
            onClose={onClose}
        >
            <Typography sx={{ color: "dark.main", marginTop: "-1rem", marginBottom: "1rem" }}>
                {innerText}
            </Typography>
            <Form content={formContent} onSubmit={onExecuted} toResetForm={false} />
            <div style={{ height: "20px" }} />
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                <SecondaryBorderButton title={acceptText} width={"300px"} onClick={onNotExecuted} />
            </div>
        </Popup>
    );
}

export default memo(OrderExecutionPopup);
